<template>
  <h1 v-if="!isModal">
    <slot />
  </h1>
  <h2 v-else class="text-center lg:text-2xl text-lg pr-0">
    <slot />
  </h2>
</template>

<script>
export default {
  props: {
    isModal: { type: Boolean, required: false, default: () => false },
  },
}
</script>
